import { media } from 'Config/styled'
import styled from 'styled-components'
import { ReactComponent as SearchIconSvg } from 'Assets/Icons/search_2.svg'

export const NoResultsContainer = styled.div`
  padding: ${({ fullWidth }) => (fullWidth ? '0' : '40px')};
  margin: 0 auto;

  ${media('lg')} {
    grid-column: span 2;
    padding: ${({ fullWidth }) => (fullWidth ? '0' : '1rem')};
  }
`

export const NoResultsBox = styled.div`
  border: 1px solid rgba(51, 51, 51, 0.24);
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  max-width: ${({ fullWidth }) => (fullWidth ? 'unset' : '660px')};
  margin: 0 auto;

  ${media('lg')} {
    width: 100%;
    max-width: unset;
    padding: 1rem;
  }
`

export const SearchIcon = styled(SearchIconSvg).withConfig({
  shouldForwardProp: prop => prop !== 'fullWidth',
})`
  ${media('lg')} {
    ${({ fullWidth }) => fullWidth && 'width: 73px; height: 73px;'}
  }
`
